<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title">Communication and Contract Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label class="account_label">Account Communication Preferences</label>
          <div class="form-check">
              <label class="form-check-label">
                  <input class="form-check-input" type="checkbox"  v-model="AccountView.toBeContactedAsVolunteer" disabled>
                  <span class="account_p">I would like to be contacted if there are volunteer opportunities in my area.</span>
              </label>
                  <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="AccountView.toReceiveNewsLetter" disabled>
                  <span class="account_p">I would like email updates from OneSight EssilorLuxottica Foundation.</span>
              </label>
          </div>
            <br>
            <label class="account_label">Program Contract</label>
            <br>
            <span class="account_p">
              <a class="g-font-size-18 just-link" v-on:click="GeneratePdf()">Click here</a> 
              <span v-if="isContractLoading">
                  <img src="../../../../../static/img/loading.gif" style="width: 25px"/>
              </span> 
              to download a copy of your contract.
            </span>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

    <loading-component v-if="isLoading"></loading-component>
     <div v-if="isModalShown">
        <div class="modal-mask" role="dialog">
          <div class="overlay-mask">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-edit-bg">
                    <div class="modal-body">
                        <div v-if="isFormLoading" class="row">
                          <page-loader></page-loader>
                        </div>
                        <div v-else>
                          <div class="close_btn" v-on:click="CloseModal()"></div><br>
                          <div class="row">
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <edit-communication-info :AccountEdit="AccountEdit" :FormInputs="FormInputs" :isFormLoading="isFormLoading"></edit-communication-info>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="SaveAccount()">Save</button>
                                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="CloseModal()">Cancel</button>
                                </div>                            
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import EditCommunicationInfo from "@/components/portal/userAccount/accountEdit/EditCommunicationInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: ['AccountView',
          'AccountEdit',
          'FormInputs',
          'isFormLoading'],
  components: {EditCommunicationInfo, LoadingComponent, PageLoader},
  data(){
    return{
      isModalShown: false,
      isLoading: false,
      isContractLoading: false      
    }
  },
  methods: {
    EditSection() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount() {
      this.isLoading = true;
      axios
        .post("/Account/CommunicationInformation", this.AccountEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.CloseModal();
            _this.$emit("success");
          } else {
            console.log("Error in Saving!");
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    },
    GeneratePdf() {
      var _this = this;
      _this.isContractLoading = true;
      var salesforceId = _this.AccountEdit.salesforceId;
      axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      })
      .then(function(response) {
          var result = response.data.raw;
          var link = document.createElement("a");
          link.href = result;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this.isContractLoading = false;
      })
      .catch(function(error) {
        console.log(error);
        _this.$router.push({name: 'Error'});
      });
    }
    }
  }
</script>



// WEBPACK FOOTER //
// CommunicationInfo.vue?546c5a04